import { render, staticRenderFns } from "./event_modal_photo_bannerimage.vue?vue&type=template&id=2875edd4&"
import script from "./event_modal_photo_bannerimage.vue?vue&type=script&lang=js&"
export * from "./event_modal_photo_bannerimage.vue?vue&type=script&lang=js&"
import style0 from "./event_modal_photo_bannerimage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports